import { Button, Modal } from "@design";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

/** Cancel + danger-button confirmation (delete, revoke...). `children` adds content under the body. */
export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  loading,
  onConfirm,
  onClose,
  children,
}: Readonly<{
  open: boolean;
  title?: string;
  body: string;
  confirmLabel: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}>) {
  const { t } = useTranslation("common");
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            {t("confirm.cancel")}
          </Button>
          <Button variant="danger" loading={loading} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <Text variant="body-sm" tone="secondary">
          {body}
        </Text>
        {children}
      </div>
    </Modal>
  );
}
